import { render, staticRenderFns } from "./UnpaidChildSupport.vue?vue&type=template&id=67d9f0c0"
import script from "./UnpaidChildSupport.vue?vue&type=script&lang=ts"
export * from "./UnpaidChildSupport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports